import { ExternalLink, Info } from '@globalvisioninc/assets/icons';
import classNames from 'classnames';
import { GVTypography } from 'components/lib';
import GVTooltip from 'components/lib/GVToolTip/GVTooltip';
import styles from './RoleHeader.module.css';

const ROLES_HELP_LINK = 'https://help.globalvision.co/verify/differences-between-tenant-admin-administrator-and';
const ROLE_INFO =
  'Administrators manage your team and account setup; users run inspections and download inspection reports.';

type RoleHeaderProps = {
  showInfo?: boolean;
  className?: string;
};

const RoleHeader = ({ showInfo = true, className }: RoleHeaderProps) => (
  <div className={classNames(styles.header, className)}>
    <GVTypography variant="subtitle1">Role</GVTypography>
    {showInfo && (
      <GVTooltip title={ROLE_INFO}>
        <Info className={styles.info} />
      </GVTooltip>
    )}
    <a className={styles.compare} href={ROLES_HELP_LINK} target="_blank" rel="noopener noreferrer">
      Compare roles and permissions
      <ExternalLink aria-hidden />
    </a>
  </div>
);

export default RoleHeader;
